import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
export var LogLevel = /*#__PURE__*/function (_Component) {
  _inherits(LogLevel, _Component);

  var _super = _createSuper(LogLevel);

  function LogLevel() {
    _classCallCheck(this, LogLevel);

    return _super.apply(this, arguments);
  }

  _createClass(LogLevel, [{
    key: "render",
    value: function render() {
      var levelText = LogLevel.levels[this.props.level];
      return /*#__PURE__*/React.createElement("span", {
        className: 'loglevel, loglevel_' + this.props.level
      }, levelText);
    }
  }]);

  return LogLevel;
}(Component);

_defineProperty(LogLevel, "levels", [t('logreader', 'Debug'), t('logreader', 'Info'), t('logreader', 'Warning'), t('logreader', 'Error'), t('logreader', 'Fatal')]);